







import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'Bio'
})
export default class Bio extends Vue {
  delay: number

  constructor () {
    super()
    this.delay = 200
  }

  visibilityChanged (isVisible: boolean, entry: any) {
    if (isVisible) {
      setTimeout(() => {
        this.delay = 0
      }, this.delay)
    } else if (entry.boundingClientRect.top >= 0) {
      this.delay = 200
    }
  }
}
